import { createSlice } from "@reduxjs/toolkit"
import { AGENT_STORE_NAME } from "../../../contants/stores";
import { Agent } from '../types/agent.data';

interface AgentState {
  agents: Agent[],
  allAgents: Agent[],
  searchQuery: string,
  status: string,
  error: Error | undefined,
  currentPage: number,
  rowsPerPage: number,
  totalCount: number
}

const initialState: AgentState = {
  agents: [],
  allAgents: [],
  searchQuery: '',
  status: 'idle',
  error: undefined,
  currentPage: 1,
  rowsPerPage: 10,
  totalCount: 0
}

export const slice = createSlice({
  name: AGENT_STORE_NAME,
  initialState,
  reducers: {
    setAgents: (state, action) => {
      state.agents = action.payload;
    },
    // updateStatus(state, action) {
    //   const agent = state.agents.find((a) => a.id === action.payload.id);
    //   if(agent) {
    //     agent.status = action.payload.status;
    //     // update active agents count
    //   }
    // },
    updateAgent: (state, action) => {
      let orderIndex = state.agents.findIndex(
        (o) => o.id === action.payload.id
      );
      if (orderIndex >= 0) {
        state.agents.splice(orderIndex, 1, {
          ...action.payload.data,
          id: action.payload.id,
        });
      }
    },
    updateSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload;
    },
    setAllAgents: (state, action) => {
      state.allAgents = action.payload;
    },

  },
});

export const actions = slice.actions
export const reducer = slice.reducer
